import React from "react";
import { Dialog, DialogActions, Typography, Button, Box, Drawer, useMediaQuery, useTheme, CircularProgress, } from "@mui/material";
import { between } from "../style/style";
import { FIconButton } from "../buttons/IButton";
import { CloseIcon } from "@ui/assets/custom-icons/close-icon";
const FDialog = ({ isOpen, onClose, onSubmit, loading = false, title, children, confirmText = "Confirm", cancelText = "Cancel", maxWidth = "md", disableActions = false, actions, forceBottomDrawer = false, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const ActionButtons = () => {
        if (disableActions)
            return null;
        if (actions)
            return React.createElement(DialogActions, { sx: { p: 3 } }, actions);
        return (React.createElement(DialogActions, { sx: { p: 3, pt: 2 } },
            React.createElement(Button, { onClick: onClose, color: "tertiary", variant: "outlined", disabled: loading, fullWidth: isMobile }, cancelText),
            React.createElement(Button, { onClick: onSubmit, variant: "contained", color: "tertiary", sx: { color: "white" }, type: "submit", disabled: loading, fullWidth: isMobile, startIcon: loading ? React.createElement(CircularProgress, { size: 16, color: "inherit" }) : null }, confirmText)));
    };
    const Header = () => (React.createElement(Box, { sx: Object.assign(Object.assign({}, between), { padding: "24px 16px", pt: isMobile ? 2 : 3, pb: 0 }) },
        React.createElement(Typography, { variant: "h6" }, title),
        React.createElement(FIconButton, { onClick: onClose, title: "Close" },
            React.createElement(CloseIcon, null))));
    const useBottomDrawer = forceBottomDrawer || isMobile;
    if (useBottomDrawer) {
        return (React.createElement(Drawer, { anchor: "bottom", open: isOpen, onClose: onClose, slotProps: {
                paper: {
                    sx: {
                        // borderTopLeftRadius: 12,
                        // borderTopRightRadius: 12,
                        maxHeight: "95dvh",
                        minHeight: "320px",
                        display: "flex",
                        flexDirection: "column",
                    },
                },
            } },
            Header(),
            React.createElement(Box, { sx: { p: 2, overflowY: "auto", flex: 1 } }, children),
            ActionButtons()));
    }
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, maxWidth: maxWidth, fullWidth: true, slotProps: {
            paper: {
                sx: {
                    maxHeight: "100dvh",
                    minHeight: "320px",
                    display: "flex",
                    flexDirection: "column",
                },
            },
        } },
        Header(),
        React.createElement(Box, { sx: { p: 2, overflowY: "auto", flex: 1 } }, children),
        ActionButtons()));
};
export default FDialog;
